// The signup consent the sign-in page shows when it offers a free account
// (during an AI assistant's connector sign-in; see LoginPage's `offerSignup`).
//
// It is the website's: `SIGNUP_CONSENT_VERSION` in bark-website's
// redesign/public/assets/forms.js, with the wording recorded under that date in
// bark-website's scripts/signup_consent_versions.json. auth-service stores the
// version with the account as the wording the person agreed to, so the text
// LoginPage renders must be that version's wording, word for word. When the
// website's wording changes, it gets a new version that day: change both here.
export const SIGNUP_CONSENT_VERSION = '2026-09-29';

export const TERMS_URL = 'https://barktechnologies.tech/terms';
export const PRIVACY_POLICY_URL = 'https://barktechnologies.tech/privacy-policy';
